import styled from '@emotion/styled';

export const Images = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	justify-content: center;
	height: 200px;
	overflow: scroll;
`;